import Cookies from 'js-cookie'
import {
  STORAGE_ITEM,
  AUTH_COOKIE,
  TOKEN_COOKIE,
  LOGIN_CHECK_COOKIE,
  LOGIN_FIRST_COOKIE,
  BA_LOGIN_CHECK_COOKIE, BEU_HOST_USER_COOKIE
} from '@/libs/constants'

export function isInIframe () {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

function setAuthToken (data) {
  if (!data.accessToken || !data.refreshToken) {
    throw new Error('invalid accessToken')
  }
  // const tokenData = {
  //   accessToken: data.accessToken,
  //   refreshToken: data.refreshToken
  // }
  // localStorage.setItem(STORAGE_ITEM.authToken, JSON.stringify(tokenData))

  Cookies.set(TOKEN_COOKIE.name, data.accessToken, {
    expires: TOKEN_COOKIE.expires,
    path: TOKEN_COOKIE.path,
    domain: TOKEN_COOKIE.domain
  })
}

export function setRefreshedAuthToken (token) {
  const tokenData = getAuthToken()
  tokenData.accessToken = token
  localStorage.setItem(STORAGE_ITEM.authToken, JSON.stringify(tokenData))
}

function removeAuthToken () {
  Cookies.remove(TOKEN_COOKIE.name, {
    path: TOKEN_COOKIE.path,
    domain: TOKEN_COOKIE.domain
  })
}

export function getAuthToken () {
  return Cookies.get(TOKEN_COOKIE.name, {
    path: TOKEN_COOKIE.path,
    domain: TOKEN_COOKIE.domain
  })
}

export function setAuthCookie (value = 1) {
  Cookies.set(AUTH_COOKIE.name, value, {
    expires: AUTH_COOKIE.expires,
    path: AUTH_COOKIE.path,
    domain: AUTH_COOKIE.domain
  })
}

function removeAuthCookie () {
  Cookies.remove(AUTH_COOKIE.name, {
    path: AUTH_COOKIE.path,
    domain: AUTH_COOKIE.domain
  })
}

export function getAuthCookie () {
  return Cookies.get(AUTH_COOKIE.name, {
    path: AUTH_COOKIE.path,
    domain: AUTH_COOKIE.domain
  })
}

export function setAuthData (data) {
  setAuthToken(data)
  setAuthCookie()
}

export function removeAuthData () {
  removeAuthToken()
  removeAuthCookie()

  removeLoginCheckCookie()
  removeFirstLoginCheckCookie()
  removeBaLoginCheckCookie()
  removeBeuHostUserCookie()
}

export function setLoginCheckCookie (value = 'Y', expires) {
  Cookies.set(LOGIN_CHECK_COOKIE.name, value, {
    expires: expires,
    path: LOGIN_CHECK_COOKIE.path,
    domain: LOGIN_CHECK_COOKIE.domain
  })
}

export function removeLoginCheckCookie () {
  Cookies.remove(LOGIN_CHECK_COOKIE.name, {
    path: LOGIN_CHECK_COOKIE.path,
    domain: LOGIN_CHECK_COOKIE.domain
  })
}

export function getLoginCheckCookie () {
  return Cookies.get(LOGIN_CHECK_COOKIE.name, {
    path: LOGIN_CHECK_COOKIE.path,
    domain: LOGIN_CHECK_COOKIE.domain
  })
}

export function setFirstLoginCookie (value = 'Y', expires = new Date('2999-12-31T23:59:59')) {
  Cookies.set(LOGIN_FIRST_COOKIE.name, value, {
    expires: expires,
    path: LOGIN_FIRST_COOKIE.path,
    domain: LOGIN_FIRST_COOKIE.domain
  })
}

export function removeFirstLoginCheckCookie () {
  Cookies.remove(LOGIN_FIRST_COOKIE.name, {
    path: LOGIN_FIRST_COOKIE.path
  })
}

export function getFirstLoginCookie () {
  return Cookies.get(LOGIN_FIRST_COOKIE.name, {
    path: LOGIN_FIRST_COOKIE.path,
    domain: LOGIN_FIRST_COOKIE.domain
  })
}

export function removeBaLoginCheckCookie () {
  Cookies.remove(BA_LOGIN_CHECK_COOKIE.name, {
    path: BA_LOGIN_CHECK_COOKIE.path,
    domain: BA_LOGIN_CHECK_COOKIE.domain
  })
}

export function setBaLoginCheckCookie (value = 'Y') {
  Cookies.set(BA_LOGIN_CHECK_COOKIE.name, value, {
    expires: BA_LOGIN_CHECK_COOKIE.expires,
    path: BA_LOGIN_CHECK_COOKIE.path,
    domain: BA_LOGIN_CHECK_COOKIE.domain
  })
}

function removeBeuHostUserCookie () {
  Cookies.remove(BEU_HOST_USER_COOKIE.name, {
    path: BEU_HOST_USER_COOKIE.path,
    domain: BEU_HOST_USER_COOKIE.domain
  })
}
